
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy-e",
      function () {
        return require("private-next-pages/privacy-policy-e.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy-e"])
      });
    }
  